import {
  GET_FITBIT_DATA,
  GET_FITBIT_DATA_SUCCESS,
  GET_FITBIT_DATA_ERROR,
  SYNC_FITBIT_DATA,
  SYNC_FITBIT_DATA_SUCCESS,
  SYNC_FITBIT_DATA_ERROR,
  GET_FITBIT_DATA_RANGE,
  GET_FITBIT_DATA_RANGE_SUCCESS,
  GET_FITBIT_DATA_RANGE_ERROR,
  GET_LATEST_FITBIT_DATA,
  GET_LATEST_FITBIT_DATA_SUCCESS,
  GET_LATEST_FITBIT_DATA_ERROR,
  SET_WEBSOCKET_CONNECTED,
  UPDATE_FITBIT_DATA_FROM_WEBSOCKET,
  CLEAR_FITBIT_ERROR,
  RESET_FITBIT,
} from './constants';

export function getFitbitData() {
  return {
    type: GET_FITBIT_DATA,
  };
}

export function getFitbitDataSuccess(payload) {
  return {
    type: GET_FITBIT_DATA_SUCCESS,
    payload,
  };
}

export function getFitbitDataError(payload) {
  return {
    type: GET_FITBIT_DATA_ERROR,
    payload,
  };
}

export function syncFitbitData() {
  return {
    type: SYNC_FITBIT_DATA,
  };
}

export function syncFitbitDataSuccess(payload) {
  return {
    type: SYNC_FITBIT_DATA_SUCCESS,
    payload,
  };
}

export function syncFitbitDataError(payload) {
  return {
    type: SYNC_FITBIT_DATA_ERROR,
    payload,
  };
}

export function getFitbitDataRange(startDate, endDate) {
  return {
    type: GET_FITBIT_DATA_RANGE,
    payload: { startDate, endDate },
  };
}

export function getFitbitDataRangeSuccess(payload) {
  return {
    type: GET_FITBIT_DATA_RANGE_SUCCESS,
    payload,
  };
}

export function getFitbitDataRangeError(payload) {
  return {
    type: GET_FITBIT_DATA_RANGE_ERROR,
    payload,
  };
}

export function getLatestFitbitData(limit = 30) {
  return {
    type: GET_LATEST_FITBIT_DATA,
    payload: { limit },
  };
}

export function getLatestFitbitDataSuccess(payload) {
  return {
    type: GET_LATEST_FITBIT_DATA_SUCCESS,
    payload,
  };
}

export function getLatestFitbitDataError(payload) {
  return {
    type: GET_LATEST_FITBIT_DATA_ERROR,
    payload,
  };
}

export function setWebSocketConnected(connected) {
  return {
    type: SET_WEBSOCKET_CONNECTED,
    payload: connected,
  };
}

export function updateFitbitDataFromWebSocket(payload) {
  return {
    type: UPDATE_FITBIT_DATA_FROM_WEBSOCKET,
    payload,
  };
}

export function clearFitbitError() {
  return {
    type: CLEAR_FITBIT_ERROR,
  };
}

export function resetFitbit() {
  return {
    type: RESET_FITBIT,
  };
}
